"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTagBehavior = void 0;
var helpers_1 = require("../../../common/helpers");
var bc_tag_constants_1 = require("./bc-tag-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_float_menu_behavior_1 = require("../../organisms/bc-float-menu/bc-float-menu-behavior");
var BcTagBehavior = (function (_super) {
    __extends(BcTagBehavior, _super);
    function BcTagBehavior() {
        return _super.call(this) || this;
    }
    BcTagBehavior.setUpAll = function () {
        var tagButtonElements = Array.from(document.querySelectorAll("div[class~='".concat(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_CONTENT, "']")));
        var elements = [];
        for (var _i = 0, tagButtonElements_1 = tagButtonElements; _i < tagButtonElements_1.length; _i++) {
            var i = tagButtonElements_1[_i];
            var bc = new BcTagBehavior();
            var element = i;
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcTagBehavior.prototype._setUp = function () {
        _super.prototype._setUp.call(this);
        this.setType();
        this.buildTag();
    };
    BcTagBehavior.prototype.setType = function () {
        var isDropdown = this.mySelf.querySelector(".".concat(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_DROPDOWN));
        var isDropdownOrButton = isDropdown ? 'dropdown' : 'button';
        this.type = this.isFilterVariant() ? 'filter' : isDropdownOrButton;
    };
    BcTagBehavior.prototype.buildTag = function () {
        if (this.type === 'button') {
            this.buildTagButton();
        }
        else if (this.type === 'filter') {
            this.buildTagFilter();
        }
        else if (this.type === 'dropdown') {
            this.buildTagDropdown();
        }
    };
    BcTagBehavior.prototype.buildTagButton = function () {
        this.setWidthCustom();
        this.addKeyboardListeners();
    };
    BcTagBehavior.prototype.buildTagFilter = function () {
        this.setWidthAuto();
        this.addIconFilter();
        this.addFiltersListeners();
    };
    BcTagBehavior.prototype.buildTagDropdown = function () {
        this.setWidthCustom();
        this.createItems();
        this.addToggleListener();
        this.addWindowListener();
        this.setupFloatMenu();
    };
    BcTagBehavior.prototype.setupFloatMenu = function () {
        var floatMenuElement = this.mySelf.querySelector(".".concat(bc_tag_constants_1.BcTagConstants.BC_FLOAT_MENU));
        var bcFloatMenuBehavior = new bc_float_menu_behavior_1.BcFloatMenuBehavior();
        bcFloatMenuBehavior.setElement(floatMenuElement);
        bcFloatMenuBehavior.setUp();
    };
    BcTagBehavior.prototype.setWidthAuto = function () {
        this.tagElement = this.mySelf;
        this.tagElement.style.setProperty('width', 'auto');
    };
    BcTagBehavior.prototype.setWidthCustom = function () {
        this.tagElement = this.mySelf;
        var widthTagAttribute = parseInt(this.mySelf.getAttribute(bc_tag_constants_1.BcTagConstants.BC_ATTRIBUTE_WIDTH_TAG));
        var widthValue = Number.isInteger(widthTagAttribute) ? "".concat(widthTagAttribute, "px") : 'auto';
        this.tagElement.style.setProperty('width', widthValue);
    };
    BcTagBehavior.prototype.handleFloatMenuOnClick = function () {
        var _this = this;
        var iconTag = this.mySelf.getElementsByClassName(bc_tag_constants_1.BcTagConstants.BC_ICON_TAG_TOGGLE)[0];
        setTimeout(function () {
            var isFloatMenuOpen = _this.mySelf.getElementsByClassName(bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE).length > 0;
            iconTag.textContent = isFloatMenuOpen ? common_constants_1.BcCommonConstants.ICON_ARROW_UP : common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            var ariaLabelValue = isFloatMenuOpen
                ? bc_tag_constants_1.BcTagConstants.BC_EXPANDED_ARIA_LABEL
                : bc_tag_constants_1.BcTagConstants.BC_CONTRACTED_ARIA_LABEL;
            iconTag.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, ariaLabelValue);
        });
    };
    BcTagBehavior.prototype.handleFloatMenuOnKeyboard = function (e) {
        var _this = this;
        var iconTag = this.mySelf.querySelector(".".concat(bc_tag_constants_1.BcTagConstants.BC_ICON_TAG_TOGGLE));
        var allowedKeyCodes = [
            common_constants_1.BcCommonConstants.KEY_EVENT_ENTER,
            common_constants_1.BcCommonConstants.KEY_EVENT_SPACE,
            common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE,
        ];
        if (allowedKeyCodes.includes(e.code)) {
            setTimeout(function () {
                var isFloatMenuOpen = _this.mySelf.getElementsByClassName(bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE).length > 0;
                var ariaLabelValue = isFloatMenuOpen
                    ? bc_tag_constants_1.BcTagConstants.BC_EXPANDED_ARIA_LABEL
                    : bc_tag_constants_1.BcTagConstants.BC_CONTRACTED_ARIA_LABEL;
                iconTag.textContent = isFloatMenuOpen ? common_constants_1.BcCommonConstants.ICON_ARROW_UP : common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
                iconTag.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, ariaLabelValue);
            });
        }
    };
    BcTagBehavior.prototype.addToggleListener = function () {
        var _this = this;
        var menuToggle = this.mySelf.getElementsByClassName(bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_TOGGLE)[0];
        menuToggle.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.handleFloatMenuOnClick(); });
        menuToggle.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (e) {
            return _this.handleFloatMenuOnKeyboard(e);
        });
    };
    BcTagBehavior.prototype.addWindowListener = function () {
        var _this = this;
        var iconTag = this.mySelf.querySelector(".".concat(bc_tag_constants_1.BcTagConstants.BC_ICON_TAG_TOGGLE));
        if (iconTag) {
            window.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                var targetElement = event.target;
                var isToggleElement = targetElement.className.includes(bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_TOGGLE);
                var isFloatMenuOption = targetElement.className.includes(bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_OPTION);
                var checkbox = targetElement.className.includes(bc_tag_constants_1.BcTagConstants.BC_CONTAINER_CHECKBOX);
                setTimeout(function () {
                    var isFloatMenuClosed = _this.mySelf.querySelector(".".concat(bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE)) === null;
                    if (isFloatMenuClosed && !isToggleElement && !isFloatMenuOption && !checkbox) {
                        iconTag.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
                        iconTag.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_tag_constants_1.BcTagConstants.BC_CONTRACTED_ARIA_LABEL);
                    }
                });
            });
        }
    };
    BcTagBehavior.prototype.addKeyboardListeners = function () {
        var _this = this;
        var tagElement = this.mySelf.querySelector('div:first-of-type');
        if (typeof tagElement.onclick == 'function') {
            tagElement.addEventListener('keydown', function (e) {
                if (e.code === 'Enter') {
                    _this.clickEventOnButton(tagElement);
                }
            });
            tagElement.addEventListener('keyup', function (e) {
                if (e.code === 'Space') {
                    _this.clickEventOnButton(tagElement);
                }
            });
        }
    };
    BcTagBehavior.prototype.clickEventOnButton = function (button) {
        button.onclick(new MouseEvent('click'));
    };
    BcTagBehavior.prototype.isFilterVariant = function () {
        var internalTag = this.mySelf.firstElementChild;
        var isFilter = internalTag.classList.contains(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_FILTER);
        var isFilterDisabled = internalTag.classList.contains(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_FILTER_DISABLED);
        return isFilter || isFilterDisabled;
    };
    BcTagBehavior.prototype.addFiltersListeners = function () {
        var _this = this;
        var tag = this.mySelf;
        tag.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.tagSelected(); });
        tag.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (e) {
            if (e.code === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || e.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                _this.tagSelected();
            }
        });
    };
    BcTagBehavior.prototype.tagSelected = function () {
        var tag = this.mySelf;
        var isFilterDisabled = tag.firstElementChild.classList.contains(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_FILTER_DISABLED);
        if (!isFilterDisabled) {
            tag.firstElementChild.classList.toggle(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_FILTER_ACTIVE);
            if (tag.firstElementChild.classList.contains(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_FILTER_ACTIVE)) {
                this.tagActive();
            }
            else {
                this.tagNoActive();
            }
        }
    };
    BcTagBehavior.prototype.addFilterObject = function (status) {
        var textFilter = this.mySelf.querySelector(common_constants_1.BcCommonConstants.P_TAG).textContent;
        return {
            idElement: this.mySelf.id,
            value: textFilter,
            selected: status,
        };
    };
    BcTagBehavior.prototype.tagActive = function () {
        var buttonSelected = this.mySelf;
        buttonSelected.firstElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, 'true');
        buttonSelected.firstElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_PRESSED, 'true');
        if (buttonSelected.firstElementChild.getAttribute(bc_tag_constants_1.BcTagConstants.BC_ATTRIBUTE_DELETE_ICON) !== 'false') {
            if (buttonSelected.firstElementChild.getAttribute(bc_tag_constants_1.BcTagConstants.BC_ATTRIBUTE_ADD_ICON) !== 'false') {
                buttonSelected.firstElementChild.lastElementChild.innerHTML = bc_tag_constants_1.BcTagConstants.BC_ICON_REMOVE_ITEM;
                buttonSelected.firstElementChild.lastElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, 'false');
                buttonSelected.firstElementChild.lastElementChild.setAttribute('tabindex', '0');
                buttonSelected.firstElementChild.lastElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_tag_constants_1.BcTagConstants.BC_ICON_REMOVE_ARIA_LABEL);
            }
            else {
                this.createIcon(bc_tag_constants_1.BcTagConstants.BC_ICON_REMOVE_ITEM, buttonSelected.firstElementChild.lastElementChild);
            }
        }
        this.outputFunction(this.addFilterObject(true));
    };
    BcTagBehavior.prototype.tagNoActive = function () {
        var buttonSelected = this.mySelf;
        buttonSelected.firstElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, 'false');
        buttonSelected.firstElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_PRESSED, 'false');
        if (buttonSelected.firstElementChild.getAttribute(bc_tag_constants_1.BcTagConstants.BC_ATTRIBUTE_ADD_ICON) !== 'false') {
            buttonSelected.firstElementChild.lastElementChild.innerHTML = bc_tag_constants_1.BcTagConstants.BC_ICON_ADD_FILTER;
            buttonSelected.firstElementChild.lastElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, 'true');
            buttonSelected.firstElementChild.lastElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, '');
            buttonSelected.firstElementChild.lastElementChild.removeAttribute('tabindex');
        }
        else {
            var removeIcon = buttonSelected.querySelector("[".concat(common_constants_1.BcCommonConstants.ARIA_LABEL, "=\"").concat(bc_tag_constants_1.BcTagConstants.BC_ICON_REMOVE_ARIA_LABEL, "\"]"));
            removeIcon === null || removeIcon === void 0 ? void 0 : removeIcon.remove();
        }
        this.outputFunction(this.addFilterObject(false));
    };
    BcTagBehavior.prototype.listenerSelectOption = function () {
        var _this = this;
        var elementLi = this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG);
        elementLi.forEach(function (element) {
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
                _this.selectOption(e);
            });
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (e) {
                if (e.code === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || e.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                    _this.selectOption(e);
                }
            });
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (e) {
                if (e.code === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                    var iconTag_1 = _this.mySelf.getElementsByClassName(bc_tag_constants_1.BcTagConstants.BC_ICON_TAG_TOGGLE)[0];
                    setTimeout(function () {
                        var isFloatMenuOpen = _this.mySelf.getElementsByClassName(bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE).length > 0;
                        if (!isFloatMenuOpen) {
                            iconTag_1.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
                            var ariaLabelValue = bc_tag_constants_1.BcTagConstants.BC_CONTRACTED_ARIA_LABEL;
                            iconTag_1.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, ariaLabelValue);
                        }
                    });
                }
            });
        });
    };
    BcTagBehavior.prototype.selectOption = function (e) {
        var iconTag = this.mySelf.getElementsByClassName(bc_tag_constants_1.BcTagConstants.BC_ICON_TAG_TOGGLE)[0];
        var valueSelected = e.currentTarget.getAttribute('data-value');
        var valueText = e.target.lastElementChild.lastElementChild.innerHTML;
        this.outputFunction(this.addValueObject(valueSelected));
        if (this.mySelf.getAttribute('showOptionSelected') == 'true') {
            this.changeValueSelected(valueText);
        }
        iconTag.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
        iconTag.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_tag_constants_1.BcTagConstants.BC_CONTRACTED_ARIA_LABEL);
    };
    BcTagBehavior.prototype.changeValueSelected = function (value) {
        var textOptionSelected = this.mySelf.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
        textOptionSelected.textContent = value;
    };
    BcTagBehavior.prototype.addValueObject = function (data) {
        return {
            idElement: this.mySelf.id,
            value: data,
        };
    };
    BcTagBehavior.prototype.createItems = function () {
        var existsLiItem = this.validateItemsExists();
        if (!existsLiItem) {
            if (this.itemsConfig) {
                var itemsList = [];
                for (var _i = 0, _a = this.itemsConfig; _i < _a.length; _i++) {
                    var itemObj = _a[_i];
                    var index = this.itemsConfig.indexOf(itemObj);
                    var li = null;
                    li = this.itemsConfig[index];
                    itemsList.push(li);
                }
                this.updateItemCreate(itemsList);
            }
        }
        else {
            this.listenerSelectOption();
        }
    };
    BcTagBehavior.prototype.addIconFilter = function () {
        var tagFilter = this.mySelf;
        if (tagFilter.firstElementChild.getAttribute(bc_tag_constants_1.BcTagConstants.BC_ATTRIBUTE_ADD_ICON) !== 'false') {
            var tagElement = this.mySelf.firstElementChild.lastElementChild;
            this.createIcon(bc_tag_constants_1.BcTagConstants.BC_ICON_ADD_FILTER, tagElement);
            tagFilter.firstElementChild.lastElementChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, 'true');
        }
    };
    BcTagBehavior.prototype.createIcon = function (icon, tagElement) {
        var el = document.createElement('em');
        el.classList.add(bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_ICON);
        el.classList.add(common_constants_1.BcCommonConstants.X_SMALL_CLASS);
        if (icon == bc_tag_constants_1.BcTagConstants.BC_ICON_REMOVE_ITEM) {
            el.tabIndex = 0;
            el.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_tag_constants_1.BcTagConstants.BC_ICON_REMOVE_ARIA_LABEL);
        }
        el.innerHTML = icon;
        this.insertAfter(el, tagElement);
    };
    BcTagBehavior.prototype.insertAfter = function (newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };
    BcTagBehavior.prototype.validateItemsExists = function () {
        return this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG).length;
    };
    BcTagBehavior.prototype.updateItemCreate = function (arrData) {
        var _this = this;
        var content = this.mySelf.querySelector(common_constants_1.BcCommonConstants.UL_TAG);
        content.innerHTML = '';
        arrData.forEach(function (item, index) {
            var liElementCreate = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.LI_TAG,
                classList: [bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_OPTION],
                props: { tabindex: 0, id: "".concat(_this.mySelf.id, "-option_").concat(index) },
                children: [
                    (0, helpers_1.createElement)({
                        element: common_constants_1.BcCommonConstants.EM_TAG,
                        innerText: item.iconName,
                        classList: [bc_tag_constants_1.BcTagConstants.BC_CLASS_NAME_ICON, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
                        props: {
                            'aria-hidden': 'true',
                        },
                    }),
                    (0, helpers_1.createElement)({
                        element: common_constants_1.BcCommonConstants.HREF_TAG,
                        children: [
                            (0, helpers_1.createElement)({
                                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                                classList: [bc_tag_constants_1.BcTagConstants.BC_CLASS_MENU_FLOAT_TEXT],
                                innerText: item.spanText,
                            }),
                        ],
                    }),
                ],
            });
            liElementCreate.dataset.value = item.value;
            content.appendChild(liElementCreate);
        });
        this.listenerSelectOption();
    };
    BcTagBehavior.prototype.setItems = function (items) {
        this.itemsConfig = items;
    };
    return BcTagBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcTagBehavior = BcTagBehavior;
